import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { ImageActions } from '../../_actions';
import { useModal } from "../../_contexts";
import { Button, Checkbox, Icon, IconButton } from "../../_components";
import ReactTooltip from "react-tooltip";
import { ImageActions } from "../../_actions";
import { useEventListener } from "../../_hooks";

export function ImageManagerForm({
  hideDetails,
  preventDetailsPane,
  // multi,
  prevModal,
}) {
  const tooltipID = "chronosImageManagerForm";
  const tooltipIcon = "far fa-info-circle";
  const { items: images } = useSelector((state) => state.images);
  const [searchVal, setSearchVal] = useState("");
  const [showDetailsPane, setShowDetailsPane] = useState(
    !preventDetailsPane ? !hideDetails : false
  );
  const [filteredImages, setFilteredImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState(["cover", "image", "map"]);
  const [multiMode, setMultiMode] = useState(false);

  const { openModal, closeModal } = useModal();

  const dispatch = useDispatch();

  //Update Search Value
  const handleSearchChange = (ev) => {
    const { value } = ev.target;
    setSearchVal(value);
  };

  //Toggle the Details Pane
  const toggleDetailsPane = (ev) => {
    if (!preventDetailsPane) {
      setShowDetailsPane(!showDetailsPane);
    }
  };

  //Toggle Multiple Select
  const toggleMultiMode = (ev) => {
    setMultiMode(!multiMode);
  };

  //Toggle Filters
  const toggleFilter = (filter) => {
    const filterIndex = filters.indexOf(filter);
    if (filterIndex > -1) {
      setFilters([
        ...filters.slice(0, filterIndex),
        ...filters.slice(filterIndex + 1),
      ]);
    } else {
      setFilters([...filters, filter]);
    }
  };

  //Close Image Manager
  const handleCloseManager = (ev) => {
    if (prevModal && prevModal.length > 0 && prevModal !== "imageManager") {
      // console.log('Close modal?', prevModal);
      openModal(prevModal);
    } else {
      closeModal();
    }
  };

  //Open Image Editor/Uploader
  const handleUploadClick = (ev) => {
    // console.log('Opening New Image Modal');
    openModal("imageModal", { prevModal: "imageManager" });
  };

  //Select Image
  const handleImageSelect = (image) => {
    if (multiMode) {
      const selectedIndex = selectedImages.findIndex(
        (i) => i._id === image._id
      );
      if (selectedIndex > -1) {
        setSelectedImages([
          ...selectedImages.slice(0, selectedIndex),
          ...selectedImages.slice(selectedIndex + 1),
        ]);
      } else {
        setSelectedImages([...selectedImages, image]);
      }
    } else {
      setSelectedImages([image]);
    }
  };

  //Handle Edit Image
  const handleImageEdit = (image) => {
    openModal("imageModal", { prevModal: "imageManager", item: image });
  };

  //Handle delete request
  const handleMultiDelete = (ev) => {
    openModal("confirmDelete", {
      prevModal: "imageManager",
      item: selectedImages,
      type: "imageMultiple",
    });
  };

  const handleSingleDelete = (image) => {
    dispatch(ImageActions.delete(image._id));
    // console.log("Deleting Image: ", image);
  };

  const handleClear = () => {
    setSelectedImages([]);
  };

  //Load the images into state
  useEffect(() => {
    setFilteredImages(images);
  }, [images]);

  // const generateSampleImages = (imageCount = 10) => {
  //   let ret = [];
  //   for (let i = 0; i < imageCount; i++) {
  //     ret.push({
  //       _id: uuid(),
  //       name: `Sample ${i + 1}`,
  //       url: `https://via.placeholder.com/400/a203f0.jpg?text=Sample+${i + 1}`,
  //       imageType: i % 3 === 0 ? "Map" : "Cover",
  //     });
  //   }
  //   return [...ret];
  // };

  //Filter Images on Search Update
  useEffect(() => {
    // setFilteredImages(generateSampleImages(47));
    // return;
    // console.log('Image Results Update', searchVal, filters);
    if (searchVal && searchVal.length > 0) {
      const searchStr = searchVal.toLowerCase();
      const results = images.filter((image) => {
        if (image.name.toLowerCase().indexOf(searchStr) > -1) {
          if (filters && filters.indexOf(image.imageType) > -1) {
            return true;
          }
          // return false;
        }
        return false;
      });

      setFilteredImages(results);
    } else {
      const results = images.filter((image) => {
        if (filters && filters.indexOf(image.imageType) > -1) {
          return true;
        }
        return false;
      });
      setFilteredImages(results);
    }
  }, [searchVal, filters]);

  const handleKeyClose = (ev) => {
    if (ev.key && ev.key.toLowerCase() === "escape") {
      handleCloseManager();
    }
  };

  const toggleFilterMenu = () => {
    setShowFilters((f) => !f);
  };

  useEventListener("keyup", handleKeyClose);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [filteredImages]);

  return (
    <div className="chronos-image-manager chronos-list-form">
      <div className="chronos-image-manager-header">
        <div className="chronos-list-search">
          <input
            type="text"
            value={searchVal}
            onChange={handleSearchChange}
            placeholder="Search Images"
            className="chronos-search-input chronos-input form-control"
          />
          <Icon icon="fas fa-search fa-fw" />
          <div
            className="chronos-search-addon chronos-search-addon-append"
            onClick={toggleFilterMenu}
          >
            <Icon icon="fas fa-filter fa-fw" />
          </div>
          {showFilters && (
            <div className="chronos-image-manager-filters">
              <h5 className="chronos-form-title">
                Filters &nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="Select the different categories to filter the images."
                  data-for={tooltipID}
                />
              </h5>
              <label className="chronos-image-manager-filter-control">
                <span className="chronos-image-filter-text">
                  <Icon icon="far fa-image-polaroid fa-fw" />
                  &nbsp;Covers
                </span>
                <Checkbox
                  value={filters.indexOf("cover") > -1}
                  onChange={() => toggleFilter("cover")}
                  custom
                />
                {/* <input
                type="checkbox"
                checked={filters.indexOf("cover") > -1}
                onChange={() => toggleFilter("cover")}
              /> */}
              </label>
              <label className="chronos-image-manager-filter-control">
                <span className="chronos-image-filter-text">
                  <Icon icon="far fa-map fa-fw" />
                  &nbsp;Maps
                </span>
                <Checkbox
                  value={filters.indexOf("map") > -1}
                  onChange={() => toggleFilter("map")}
                  custom
                />
                {/* <input
                type="checkbox"
                checked={filters.indexOf("map") > -1}
                onChange={() => toggleFilter("map")}
              /> */}
              </label>
              {/* <label className="chronos-image-manager-filter-control">
              
              <span className="chronos-image-filter-text">
                <Icon icon="far fa-image fa-fw" />
              &nbsp;Images
              </span>
              <input
                type="checkbox"
                checked={filters.indexOf("image") > -1}
                onChange={() => toggleFilter("image")}
              />
            </label> */}
            </div>
          )}
        </div>
        <Button color="success" onClick={handleUploadClick}>
          <Icon icon="fas fa-upload fa-fw" />
          &nbsp;Upload Image
        </Button>
      </div>
      <div className="chronos-image-manager-content">
        {filteredImages &&
          filteredImages.length > 0 &&
          filteredImages.map((image) => (
            <ImageItem
              image={image}
              key={image._id}
              onSelect={handleImageSelect}
              onEdit={handleImageEdit}
              onDelete={handleSingleDelete}
              active={selectedImages.findIndex((i) => i._id === image._id) > -1}
              tooltipID={tooltipID}
            />
          ))}
      </div>
      <ReactTooltip id={tooltipID} effect="solid" />
    </div>
  );
  // return (
  //   <div className="chronos-image-manager">
  //     <div className="chronos-image-manager-sidebar">
  //       <div className="chronos-image-manager-sidebar-search">
  //         <input
  //           type="text"
  //           value={searchVal}
  //           onChange={handleSearchChange}
  //           placeholder="Search Images"
  //           className="chronos-search chronos-input form-control"
  //         />

  //         <div className="chronos-image-manager-filters">
  //           <h5 className="chronos-image-manager-sidebar-title">
  //             Filters &nbsp;
  //             <Icon
  //               icon={tooltipIcon}
  //               data-tip="Select the different categories to filter the images."
  //               data-for={tooltipID}
  //             />
  //           </h5>
  //           <label className="chronos-image-manager-filter-control">
  //             <input
  //               type="checkbox"
  //               checked={filters.indexOf('cover') > -1}
  //               onChange={() => toggleFilter('cover')}
  //             />
  //             <Icon icon="far fa-image-polaroid fa-fw" />
  //             &nbsp;Covers
  //           </label>
  //           <label className="chronos-image-manager-filter-control">
  //             <input
  //               type="checkbox"
  //               checked={filters.indexOf('map') > -1}
  //               onChange={() => toggleFilter('map')}
  //             />
  //             <Icon icon="far fa-map fa-fw" />
  //             &nbsp;Maps
  //           </label>
  //           <label className="chronos-image-manager-filter-control">
  //             <input
  //               type="checkbox"
  //               checked={filters.indexOf('image') > -1}
  //               onChange={() => toggleFilter('image')}
  //             />
  //             <Icon icon="far fa-image fa-fw" />
  //             &nbsp;Images
  //           </label>
  //         </div>
  //         <div className="chronos-image-manager-options">
  //           <h5 className="chronos-image-manager-sidebar-title">
  //             View Options&nbsp;
  //             <Icon
  //               icon={tooltipIcon}
  //               data-tip="Toggle Multi-Select mode on/off."
  //               data-for={tooltipID}
  //             />
  //           </h5>
  //           <IconButton
  //             icon={multiMode ? 'far fa-images fa-fw' : 'far fa-image fa-fw'}
  //             data-tip={
  //               multiMode ? 'Turn multi-select Off' : 'Turn multi-select On'
  //             }
  //             color={multiMode ? 'warning' : 'info'}
  //             onClick={toggleMultiMode}
  //           />
  //           <ReactTooltip effect="solid" />
  //         </div>
  //       </div>
  //       <div className="chronos-image-manager-sidebar-upload">
  //         <Button color="info" block onClick={handleUploadClick}>
  //           <Icon icon="far fa-upload fa-fw" />
  //           &nbsp;Upload Image
  //         </Button>
  //       </div>
  //     </div>
  //     <div className="chronos-image-manager-files-pane">
  //       <div className="chronos-image-manager-files">
  //         <div className="chronos-image-manager-files-list">
  //           {filteredImages && filteredImages.length > 0 && (
  //             <React.Fragment>
  //               {filteredImages.map((image) => (
  //                 <ImageItem
  //                   image={image}
  //                   key={image._id}
  //                   onSelect={handleImageSelect}
  //                   active={
  //                     selectedImages.findIndex((i) => i._id === image._id) > -1
  //                   }
  //                 />
  //               ))}
  //             </React.Fragment>
  //           )}
  //         </div>
  //         {!preventDetailsPane && (
  //           <DetailsPane
  //             open={showDetailsPane}
  //             toggle={toggleDetailsPane}
  //             edit={handleImageEdit}
  //             selectedItems={selectedImages}
  //             handleDelete={handleMultiDelete}
  //             handleClear={handleClear}
  //           />
  //         )}
  //       </div>
  //       <div className="chronos-image-manager-footer">
  //         <Button color="primary" onClick={handleCloseManager}>
  //           <Icon icon="far fa-times fa-fw" />
  //           Close
  //         </Button>
  //       </div>
  //     </div>
  //     <ReactTooltip effect="solid" id={tooltipID} />
  //   </div>
  // );
}

function DetailsPane({
  open,
  toggle,
  selectedItems,
  edit,
  handleDelete,
  handleClear,
}) {
  const classes = ["chronos-image-manager-details-pane"];
  if (open) {
    classes.push("open");
  }

  // const handleToggle = (ev) => {
  //   if (toggle) {
  //     toggle();
  //   }
  // };

  const handleDeleteImages = (ev) => {
    if (handleDelete) {
      handleDelete();
    }
  };

  const handleEdit = (ev) => {
    if (edit) {
      edit(selectedItems[0]);
    }
  };

  const handleClearSelection = () => {
    if (handleClear) handleClear();
  };

  const hasSelectedItems = selectedItems && selectedItems.length > 0;
  const isSingleItem = hasSelectedItems && selectedItems.length === 1;
  const isMultiItem = hasSelectedItems && selectedItems.length > 1;

  return (
    <div className={classes.join(" ")}>
      {/* <div className="chronos-pane-toggle">
        <IconButton
          icon={'far fa-chevron-left fa-fw' + (open ? ' fa-rotate-180' : '')}
          onClick={handleToggle}
          iconColor="#3f3f3f"
        />
      </div> */}
      <div className="chronos-pane-header">
        <h5 className="chronos-pane-title">Details</h5>
      </div>
      <div className="chronos-pane-body">
        {!hasSelectedItems && (
          <div className="text-muted">No images selected</div>
        )}
        {isMultiItem && (
          <div className="text-muted">
            {selectedItems.length} Images Selected
          </div>
        )}
        {isSingleItem && (
          <div className="item-info">
            <div className="item-property">Name</div>
            <div className="item-value">
              {selectedItems[0].name || (
                <span className="text-muted">No Name</span>
              )}
            </div>
            <div className="item-property">Type</div>
            <div className="item-value">
              {selectedItems[0].imageType === "image" && (
                <span>
                  <Icon icon="far fa-image fa-fw" />
                  &nbsp;Image
                </span>
              )}
              {selectedItems[0].imageType === "map" && (
                <span>
                  <Icon icon="far fa-map fa-fw" />
                  &nbsp;Map
                </span>
              )}
              {selectedItems[0].imageType === "cover" && (
                <span>
                  <Icon icon="far fa-image-polaroid fa-fw" />
                  &nbsp;Cover
                </span>
              )}
            </div>
            <div className="item-property">Width</div>
            <div className="item-value">
              {selectedItems[0].properties.width ? (
                selectedItems[0].properties.width + " px"
              ) : (
                <span className="text-muted">No Data</span>
              )}
            </div>
            <div className="item-property">Height</div>
            <div className="item-value">
              {selectedItems[0].properties.height ? (
                selectedItems[0].properties.height + " px"
              ) : (
                <span className="text-muted">No Data</span>
              )}
            </div>
          </div>
        )}
      </div>
      {hasSelectedItems && (
        <div
          className="chronos-pane-footer"
          style={{ flexDirection: isMultiItem ? "column" : "row" }}
        >
          {isMultiItem && (
            <Button
              color="warning"
              block
              style={{ marginBottom: "0.5rem" }}
              onClick={handleClearSelection}
            >
              <Icon icon="far fa-times fa-fw" />
              &nbsp;Clear Selection
            </Button>
          )}
          <Button
            color="danger"
            block={isMultiItem}
            onClick={handleDeleteImages}
          >
            <Icon icon="far fa-trash fa-fw" />
            {isSingleItem && "Delete"}
            {isMultiItem && `Delete ${selectedItems.length} Images`}
          </Button>
          {isSingleItem && (
            <Button color="info" onClick={handleEdit}>
              <Icon icon="far fa-edit fa-fw" />
              &nbsp;Edit
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

function ImageItem({ image, onSelect, onDelete, onEdit, active, tooltipID }) {
  const imageRef = useRef();

  const handleClick = (ev) => {
    console.log("Selected Image: ", image);
    if (onSelect) {
      onSelect(image);
    }
  };

  const handleImageError = (ev) => {
    ev.target.src = "https://www.worldanvil.com/images/placeholder-cyan.jpg";
  };

  const handleDelete = (ev) => {
    if (onDelete) {
      ev.preventDefault();
      ev.stopPropagation();
      onDelete(image);
    }
  };

  const handleEdit = (ev) => {
    if (onEdit) {
      ev.preventDefault();
      ev.stopPropagation();
      onEdit(image);
    }
  };

  let classes = ["chronos-image-item"];
  if (active) {
    classes.push("chronos-selected-image");
  }

  // tooltipID = `${tooltipID}-${image._id}`;

  return (
    <div
      className={classes.join(" ")}
      onClick={handleClick}
      style={{ backgroundImage: `url(${image.url})` }}
    >
      <div className="chronos-image-item-controls">
        <h4 className="chronos-image-item-type">{image.imageType}</h4>
        <div className="chronos-image-item-options">
          <IconButton
            onClick={handleEdit}
            iconOnly
            data-for={tooltipID}
            data-tip="Edit"
            icon="fas fa-pencil fa-fw"
          />
          <IconButton
            onClick={handleDelete}
            iconOnly
            data-for={tooltipID}
            data-tip="Delete"
            icon="fas fa-trash fa-fw"
          />
        </div>

        {/* <img
          onError={handleImageError}
          src={image.url}
          alt={image.name}
          ref={imageRef}
        /> */}
      </div>
      <div className="chronos-image-item-title">{image.name}</div>
      {/* <ReactTooltip id={tooltipID} effect="solid" /> */}
    </div>
  );
}
